import { useMutation, useQuery } from "@apollo/client";
import { Box, Center, Flex, useToast } from "@chakra-ui/react";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import React, { Fragment, useState } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import LoggedInActionLinks from "../components/Classes/ActionLinks";
import NotificationComp from "../components/Classes/Notification";
import { NetworkError } from "../components/UI/Error";
import Empty from "../components/UI/Errors/Empty";
import Loader from "../components/UI/Loader";
import Toast from "../components/UI/Toast";
import UserLayoutv2 from "../components/UserLayoutv2";
import { ACCEPTINVITATION, DECLINEINVITATION } from "../graphql/Mutations/Class";
import { GET_JOINED_CLASSES } from "../graphql/queries/class";
import { GET_INVITATIONS } from "../graphql/queries/Student";
import { PrivateRoute } from "../Helpers/PrivateRoute";
import { activeClass, authData } from "../State";

// import Dummy from './../components/UI/Dummy';
const LoginPage = dynamic(() => import("./login"));

const Notifications = () => {
  const toast = useToast();

  // router
  const router = useRouter();

  // recoil
  const { loggedIn, studentData } = useRecoilValue(authData);
  const setActiveClass = useSetRecoilState(activeClass);
  // const { refetchClasses } = useRecoilValue(classRefetch);

  // state
  const [classidToManipulate, setclassIdToManipulate] = useState("");
  const [classNameToJoin, setClassNameToJoin] = useState("");

  //========================= Graphql ========================================
  const { loading, error, data, refetch } = useQuery(GET_INVITATIONS, {
    fetchPolicy: "cache-first",
    onError: () => {
      return null;
    },
  });

  const invitationsData = data ? data.get_student_profile.invitations : {};

  const [acceptInvite, { loading: acceptLoading }] = useMutation(ACCEPTINVITATION, {
    onCompleted({ accept_class_invitation }) {
      // const { value, message, class: joinedClass } = accept_class_invitation;
      const { value, message } = accept_class_invitation;
      if (value) {
        // show success toast
        toast({
          position: "top",
          duration: 7000,
          render: (props) => <Toast title={message} props={props} />,
        });

        // set active class
        // setActiveClass({
        //   active_class_id: joinedClass && joinedClass._id,
        //   active_class_name: joinedClass && joinedClass.class_name
        // })

        // push to class page
        // refetchClasses();
        setActiveClass({
          active_class_id: classidToManipulate,
          active_class_name: classNameToJoin,
        });
        refetch();
        router.push(`/classes/enrolled/${classidToManipulate}`);

        // if (typeof window !== "undefined") {
        //   window.location.href = `/classes/enrolled/${classidToManipulate}`
        // }
      } else {
        toast({
          position: "top",
          duration: 7000,
          render: (props) => <Toast title={message} props={props} />,
        });
      }
    },
    onError: () => {
      return null;
    },
    refetchQueries: [{ query: GET_JOINED_CLASSES }],
  });

  const [declineInvite, { loading: declineLoading }] = useMutation(DECLINEINVITATION, {
    onCompleted({ decline_class_invitation }) {
      const { value, message } = decline_class_invitation;
      if (value) {
        toast({
          position: "top",
          duration: 7000,
          render: (props) => <Toast title="Invite declined" props={props} />,
        });
        refetch();
      } else {
        toast({
          position: "top",
          duration: 7000,
          render: (props) => <Toast title={message} props={props} />,
        });
        refetch();
      }
    },
    onError: () => {
      return null;
    },
  });
  React.useEffect(() => {
    if (loggedIn) return;
    router.replace("/notifications", "/login", { shallow: true });
  }, [loggedIn]);

  // ========================================================================
  if (!loggedIn) return <LoginPage />;
  if (typeof window !== "undefined") {
    return (
      <UserLayoutv2
        title="Notifications"
        customLeftWidth={{ base: "0%", lg: "20%" }}
        left={
          <Fragment>
            {loggedIn ? (
              <LoggedInActionLinks classesData={studentData.joined_classes} />
            ) : (
              <Box h="100%" py={10} px={12}>
                {/* <Filter /> */}
              </Box>
            )}
          </Fragment>
        }
        customMainWidth={loggedIn ? { base: "100%", lg: "60%" } : { base: "100%", lg: "80%" }}
        main={
          <Box px={12}>
            {loading && (
              <Center h="60vh">
                <Loader />
              </Center>
            )}

            {!loading && !error && (
              <Fragment>
                <Box overflowX="hidden">
                  <Flex flex="1" flexDir="column" overflowY="auto" mx="auto" paddingY={4}>
                    {error && <NetworkError />}
                    {!loading && invitationsData.length > 0
                      ? invitationsData.map((item: any, index: number) => (
                          <NotificationComp
                            data={item}
                            declineInvite={async () => {
                              await declineInvite({
                                variables: {
                                  classId: item._id,
                                },
                              });
                            }}
                            acceptInvite={async () => {
                              setclassIdToManipulate(item._id);
                              setClassNameToJoin(item.class_name);

                              await acceptInvite({
                                variables: {
                                  classId: item._id,
                                },
                              });
                            }}
                            isAccepting={acceptLoading}
                            isDeclining={declineLoading}
                          />
                        ))
                      : null}
                    {invitationsData && invitationsData.length === 0 && (
                      <Empty type="notifications" title="No Invitations" subtitle="You do not have any new notifications." />
                    )}
                  </Flex>
                </Box>
              </Fragment>
            )}
          </Box>
        }
        customRightWidth={loggedIn ? { base: "0%", lg: "20%" } : "0"}
        right={<Box d={loggedIn ? { base: "none", lg: "block" } : "none"} h="100%" pt={10} px={6}></Box>}
      />
    );
  } else {
    return <></>;
  }
};

export default PrivateRoute(Notifications);
